import { Box, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import createAxiosInstance from '../../api/axiosConfig';
import { QUEST_LISTING_API } from '../../api/endpoint';
import Loader from '../../components/loader';
import scoreIcon from '../../assets/QuestCoinsIcon.png';

const Quests = () => {
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [selectedQuest, setSelectedQuest] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const Easy = 'radial-gradient(67.32% 67.32% at 50% 50%, #27B807 0%, #27D101 100%)';
  const Moderate = 'radial-gradient(70.47% 70.47% at 50% 50%, #DA9E00 0%, #FFB900 100%)';
  const Advanced = 'radial-gradient(68.9% 68.9% at 50% 50%, #FF8800 0%, #FF7700 100%)';
  const Expert = ' radial-gradient(96.46% 96.46% at 50% 50%, rgba(213, 0, 0, 0.8) 0%, rgba(255, 0, 0, 0.8) 100%)';
  const handleClick = (quest: any) => {
    setSelectedQuest(quest);
    setDialogOpen(true);
    navigate(`/quest?q=${quest.contest_code}`, {
      state: { quest }
    });
  };
  const difficultyLabels = ['Easy', 'Moderate', 'Advanced', 'Expert'];

  const difficultyBg = [Easy, Moderate, Advanced, Expert];

  const fetchQuest = async () => {
    setLoading(true);
    try {
      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${QUEST_LISTING_API}MICRO_CONTEST`, {});
      setData(response.data.data);
    } catch (error) {
      console.error('Error fetching contests:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuest();
  }, []);

  return (
    <>
      <div>
        <Typography
          style={{
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '24px' : '48px',
            fontWeight: 800,
            color: 'white',
            textAlign: 'center',
            paddingBottom: '40px'
          }}>
          ALL QUESTS
        </Typography>
        {loading && <Loader />}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: isMobile ? '28px' : '25px',
            margin: isMobile ? '0 10%' : '0 5%'
          }}>
          {data &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
              const createdAt = new Date(item.created_at);
              const now = new Date();
              const diffInMilliseconds = now.getTime() - createdAt.getTime();
              const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
              const isLessThan7DaysOld = diffInDays < 8;
              return (
                <div
                  key={index}
                  onClick={() => handleClick(item)}
                  style={{
                    flex: isMobile ? 'flex: 1 1 calc(100% / 2 - 10px) ' : '1 1 calc(100% / 4 - 21px)',
                    maxWidth: isMobile ? 'calc(100% / 2 - 16px)' : 'calc(100% / 4 - 16px)',
                    textAlign: 'center',
                    height: isMobile ? '250px' : '440px',
                    width: isMobile ? '400px' : '200px',
                    cursor: 'pointer'
                  }}>
                  <div
                    style={{
                      position: 'relative',
                      height: '60%',
                      borderRadius: '14px 14px 0 0'
                    }}>
                    <div
                      style={{
                        position: 'absolute',
                        backgroundImage: 'linear-gradient(to bottom, rgb(0,0,0,0.9), transparent)',
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        gap: '5px',
                        height: '20%',
                        width: '100%',
                        borderRadius: '14px 14px 0 0'
                      }}>
                      <img
                        alt={'score-icon'}
                        style={{
                          height: isMobile ? '20px' : 'auto',
                          width: isMobile ? '20px' : 'auto',
                          left: isMobile ? '10%' : 0,
                          top: isMobile ? 2 : 5
                        }}
                        src={scoreIcon}></img>
                      <Typography
                        sx={{
                          fontFamily: 'Baloo2',
                          fontWeight: 800,
                          fontSize: isMobile ? '14px' : '21px',
                          color: 'white'
                        }}>{`${item.winning_points} Points`}</Typography>
                    </div>
                    <img
                      style={{
                        height: '100%',
                        width: '100%',
                        borderRadius: '14px 14px 0 0',
                        zIndex: 0
                      }}
                      src={`${process.env.REACT_APP_DEFAULT_AVATAR}/MICRO_CONTESTS/${item.contest_id}/IMAGES/medium/${item.ct_banner}`}
                      alt="Quest"
                    />
                    {isLessThan7DaysOld && (
                      <Typography
                        style={{
                          backgroundColor: 'red',
                          color: 'white',
                          borderRadius: '8px 0 16px 0',
                          width: isMobile ? '30%' : '20%',
                          textAlign: 'center',
                          position: 'absolute',
                          top: '20%',
                          zIndex: 1
                        }}>
                        New
                      </Typography>
                    )}
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '-15px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        borderRadius: '8px',
                        textTransform: 'uppercase',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        padding: '5px 12px'
                      }}>
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          background: 'rgba(255, 255, 255, 0.8)',
                          filter: 'blur(1px)',
                          borderRadius: '8px'
                        }}></div>

                      <Typography
                        style={{
                          position: 'relative',
                          color: 'black',
                          fontSize: isMobile ? '12px' : '22px',
                          fontWeight: '500',
                          textAlign: 'center',
                          fontFamily: 'Baloo2'
                        }}>
                        {(difficultyLabels &&
                          difficultyLabels.length > 0 &&
                          difficultyLabels[item.difficulty_level - 1]) ||
                          'Hard'}
                      </Typography>
                    </div>
                  </div>

                  <div style={{ height: '40%' }}>
                    <div
                      style={{
                        background: difficultyBg[item.difficulty_level - 1] || Expert,
                        backgroundSize: '100% 100%',
                        height: '100%',
                        borderRadius: '0 0 14px 14px'
                      }}>
                      <Typography
                        style={{
                          fontFamily: 'Baloo2',
                          color: 'white',
                          fontSize: isMobile ? '16px' : '29px',
                          fontWeight: '800',
                          textAlign: 'center',
                          padding: '15px 0 0 0'
                        }}>
                        {item.title.length > 14 ? item.title.slice(0, 14) + '...' : item.title}
                      </Typography>

                      <Typography
                        style={{
                          fontFamily: 'Baloo2',
                          color: 'white',
                          fontSize: isMobile ? '8px' : '14px',
                          fontWeight: '500',
                          textAlign: 'center',
                          padding: '5px',
                          whiteSpace: 'normal',
                          height: isMobile ? '20%' : '30%'
                        }}>
                        {item.description.length > (isMobile ? 60 : 100)
                          ? item.description.slice(0, isMobile ? 60 : 100) + '...'
                          : item.description}
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(180px)', // ✅ apply blur to background
                          backgroundColor: 'rgba(255, 255, 255, 0.1)', // ✅ semi-transparent white
                          borderRadius: '20px',
                          padding: '5px 10px',
                          width: '40%',
                          margin: '8% 30%'
                        }}>
                        <Typography
                          sx={{
                            fontFamily: 'Baloo2',
                            color: 'white',
                            fontSize: isMobile ? '8px' : '14px',
                            fontWeight: 500,
                            textAlign: 'center',
                            whiteSpace: 'normal'
                          }}>
                          {item.category}
                        </Typography>
                      </Box>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};
export default Quests;
